import { BaseApiService } from '../../../api/base';
import type { BankCard, BankCardAuthForm } from '../types/bankCard';

class BankCardApiService extends BaseApiService {
  public getUserBankCards(): Promise<BankCard[]> {
    return this.get<BankCard[]>('loans/user/bank-cards');
  }

  public initBankCardAuth(): Promise<BankCardAuthForm> {
    return this.get<BankCardAuthForm>('loans/cards/auth-data/5'); // 5 = VOLT_WEB
  }
}

export const bankCardApiService = new BankCardApiService();
